import { useState } from 'react';
import { Settings, X } from 'lucide-react';
import { useAuth } from '../auth/store';

interface SettingsDialogProps {
  open: boolean;
  onClose: () => void;
}

export const SettingsDialog = ({ open, onClose }: SettingsDialogProps) => {
  const apiKey = useAuth((s) => s.apiKey);
  const setApiKey = useAuth((s) => s.setApiKey);
  const [keyDraft, setKeyDraft] = useState(apiKey ?? '');

  if (!open) return null;

  const save = () => {
    setApiKey(keyDraft.trim() || null);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/70 p-4 backdrop-blur">
      <div className="card w-full max-w-lg">
        <div className="mb-3 flex items-center justify-between">
          <h3 className="text-base font-semibold">
            <Settings className="mr-2 inline h-4 w-4 text-archer-300" />
            Settings
          </h3>
          <button className="tool-btn" onClick={onClose}>
            <X className="h-4 w-4" />
          </button>
        </div>

        <label className="label">Omniapps AI API key</label>
        <input
          className="input font-mono text-xs"
          type="password"
          value={keyDraft}
          onChange={(e) => setKeyDraft(e.target.value)}
          placeholder="oak_xxxxxxxxx"
        />
        <p className="mt-1 text-xs text-slate-500">
          Create one in your{' '}
          <a
            href="https://account.omniapps.net/keys"
            target="_blank"
            rel="noreferrer"
            className="underline"
          >
            Omniapps Account → API Keys
          </a>
          . The key is stored locally in this browser and is used to call the AI diagram service.
        </p>

        <div className="mt-4 flex justify-end gap-2">
          <button className="btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="btn-primary" onClick={save}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};
